import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "16_event-default.svg",
  "use": "16_event-default.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"16_event-default.svg\"><rect width=\"16\" height=\"16\" style=\"fill:none\" /><circle cx=\"7.5\" cy=\"7.5\" r=\"7\" style=\"fill:#fafafa;stroke:#ed8733;stroke-miterlimit:10\" /><path d=\"M5.6,11l4-4H7.42l1.5-3H7.23l-2,4H7l-1.5,3Z\" style=\"fill:#f8db8f\" /><path d=\"M8.23,6.5h2.58l-5,5H4.67l1.5-3H4.42l2.5-5H9.73ZM5.6,11l4-4H7.42l1.5-3H7.23l-2,4H7l-1.5,3Z\" style=\"fill:#ed8733\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol